var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.75 16.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_code") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.86,27.47a.67.67,0,0,1,.24.54,1.27,1.27,0,0,1-.07.38c-.1.24-.27.43-.48.43a.47.47,0,0,1-.27-.11l-5.17-3.82a1,1,0,0,1-.52-.94,1.09,1.09,0,0,1,.53-1l5.18-3.77a.4.4,0,0,1,.25-.1.56.56,0,0,1,.48.43.86.86,0,0,1,.09.39.6.6,0,0,1-.26.52l-4.92,3.51Z",
    transform: "translate(-14.59 -15.07)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.12,31.16c-.08.29-.24.43-.45.43a.57.57,0,0,1-.27-.07A.6.6,0,0,1,22,31a.8.8,0,0,1,.05-.26L26.79,15.5a.51.51,0,0,1,.49-.43.53.53,0,0,1,.25,0,.6.6,0,0,1,.39.56,1,1,0,0,1-.05.28Z",
    transform: "translate(-14.59 -15.07)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.06,20.42a.65.65,0,0,1-.25-.54,1,1,0,0,1,.07-.37.57.57,0,0,1,.48-.43.41.41,0,0,1,.26.1L34.8,23a1.11,1.11,0,0,1,.53,1,1,1,0,0,1-.52.94l-5.19,3.82a.4.4,0,0,1-.25.11c-.23,0-.39-.19-.49-.43a1,1,0,0,1-.07-.38.65.65,0,0,1,.25-.54L34,23.93Z",
    transform: "translate(-14.59 -15.07)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCode);
export default __webpack_public_path__ + "static/media/ic_code.5881e99a929e1384f7b699ba443d503b.svg";
export { ForwardRef as ReactComponent };